<script>
import api from '@/helpers/api'
import { required } from 'vuelidate/lib/validators'
import stepHelper from './step-helper'
export default {
  name: 'customer.form.billing_address.general',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: () => ({
    form: {
      billing_address: { country_code: 'BE' }
    }
  }),
  mixins: [stepHelper],
  methods: {
    validate () {
      return this.__validateForm()
    }
  },
  validations () {
    return {
      form: {
        billing_address: {
          line1: {
            required
          },
          zipcode: { required },
          city: { required },
          country_code: { required }
        }
      }
    }
  }
}
</script>
<template>
  <div>
    <b-form-group label="Attn." label-for="attn" label-cols-sm="3">
      <b-form-input
        id="line1"
        v-model="form.billing_address.attn"
        placeholder="Name of Person or Department"
        autocomplete="attn"
        :style="{ width: '350px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Addressline 1" label-for="line1" label-cols-sm="3">
      <b-form-input
        id="line1"
        v-model="form.billing_address.line1"
        autocomplete="addressline1"
        placeholder="Street and number"
        :style="{ width: '450px' }"
        :class="{ 'is-invalid': $v.form.billing_address.line1.$error }"
        aria-describedby="err_line1"
      ></b-form-input>
      <b-form-invalid-feedback id="err_line1">
        <template v-if="!$v.form.billing_address.line1.required">
          Field is required
        </template>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Addressline 2" label-for="line2" label-cols-sm="3">
      <b-form-input
        id="line2"
        v-model="form.billing_address.line2"
        autocomplete="addressline2"
        placeholder="Additional info ex. bus, floor, department"
        :style="{ width: '450px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="Zipcode" label-for="zipcode" label-cols-sm="3">
      <b-form-input
        id="zipcode"
        v-model="form.billing_address.zipcode"
        autocomplete="zipcode"
        placeholder="Zipcode"
        :style="{ width: '150px' }"
        :class="{ 'is-invalid': $v.form.billing_address.zipcode.$error }"
        aria-describedby="err_zipcode"
      ></b-form-input>
      <b-form-invalid-feedback id="err_zipcode">
        <template v-if="!$v.form.billing_address.zipcode.required">
          Field is required
        </template>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="City" label-for="city" label-cols-sm="3">
      <b-form-input
        id="city"
        v-model="form.billing_address.city"
        autocomplete="city"
        placeholder="City"
        :style="{ width: '280px' }"
        :class="{ 'is-invalid': $v.form.billing_address.city.$error }"
        aria-describedby="err_city"
      ></b-form-input>
      <b-form-invalid-feedback id="err_city">
        <template v-if="!$v.form.billing_address.city.required">
          Field is required
        </template>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label="Country" label-for="country_code" label-cols-sm="3">
      <app-country-select
        id="country_code"
        v-model="form.billing_address.country_code"
        :style="{ width: '50%' }"
      />
    </b-form-group>
  </div>
</template>
